import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from '@/components/Button';
import NotFoundImg from '@/images/not-found.svg';
import routes from '@/routes';
import { setPageNotFound } from '@/store/site';
import { localizedRoute } from '@/utils/locale';

function NotFound() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const { from } = location.state || {};

	const messagesMappings = {
		pdf: {
			title: t('pageTitles.editorNotFound'),
			description: t('notFound.editorDescription')
		},
		default: {
			title: t('pageTitles.notFound'),
			description: t('notFound.description')
		}
	};

	const currentMessages = messagesMappings[from] || messagesMappings.default;

	useEffect(() => {
		dispatch(setPageNotFound(true));

		return () => {
			dispatch(setPageNotFound(false));
		};
	}, []);

	return (
		<div
			data-page-not-found
			className="flex flex-col items-center justify-center bg-black"
		>
			<div className="container mb-20 mt-12 flex flex-col lg:mb-[90px] lg:mt-[120px] lg:items-center lg:justify-center">
				<img
					src={NotFoundImg}
					alt={currentMessages.title}
					className="mb-7 lg:mb-[30px]"
					width={580}
					height={352}
				/>
				<h1 className="mb-3 font-title text-[32px] font-semibold leading-10 text-white lg:text-[56px] lg:font-bold lg:leading-[64px]">
					{currentMessages.title}
				</h1>
				<h2 className="text-sm leading-6 text-white lg:text-base lg:leading-7">
					{currentMessages.description}
				</h2>
				<Button
					variant="outlineWhite"
					onClick={() => navigate(localizedRoute(routes.home))}
					className="mt-7 self-start px-6 py-2 lg:mt-6 lg:self-center"
				>
					{t('common.back')}
				</Button>
			</div>
		</div>
	);
}

export default NotFound;
